// AUTO-GENERATED FILE — DO NOT EDIT

export const Icons = {
	Accessibility: () => import('./Accessibility').then((module) => module.Accessibility),
	Addon: () => import('./Addon').then((module) => module.Addon),
	Airplane: () => import('./Airplane').then((module) => module.Airplane),
	AlarmClock: () => import('./AlarmClock').then((module) => module.AlarmClock),
	AmericanExpressCreditCard: () =>
		import('./credit-card/AmericanExpressCreditCard').then((module) => module.AmericanExpressCreditCard),
	Archive: () => import('./Archive').then((module) => module.Archive),
	ArrowDown: () => import('./Arrow-down').then((module) => module.ArrowDown),
	ArrowDownRight: () => import('./Arrow-down-right').then((module) => module.ArrowDownRight),
	ArrowDownSmall: () => import('./ArrowDownSmall').then((module) => module.ArrowDownSmall),
	ArrowLeft: () => import('./Arrow-left').then((module) => module.ArrowLeft),
	ArrowRight: () => import('./Arrow-right').then((module) => module.ArrowRight),
	ArrowUp: () => import('./Arrow-up').then((module) => module.ArrowUp),
	ArrowUpSmall: () => import('./ArrowUpSmall').then((module) => module.ArrowUpSmall),
	At: () => import('./At').then((module) => module.At),
	Attachment: () => import('./Attachment').then((module) => module.Attachment),
	Barcode: () => import('./Barcode').then((module) => module.Barcode),
	BatteryCharging: () => import('./BatteryCharging').then((module) => module.BatteryCharging),
	Beaker01: () => import('./Beaker01').then((module) => module.Beaker01),
	Beaker02: () => import('./Beaker02').then((module) => module.Beaker02),
	BookOpen: () => import('./BookOpen').then((module) => module.BookOpen),
	Building: () => import('./Building').then((module) => module.Building),
	Bus: () => import('./Bus').then((module) => module.Bus),
	Calendar: () => import('./Calendar').then((module) => module.Calendar),
	CalendarRepeat: () => import('./Calendar-repeat').then((module) => module.CalendarRepeat),
	CalendarUnavailable: () => import('./Calendar-unavailable').then((module) => module.CalendarUnavailable),
	Camera: () => import('./Camera').then((module) => module.Camera),
	Car: () => import('./Car').then((module) => module.Car),
	Cart: () => import('./Cart').then((module) => module.Cart),
	Categories: () => import('./Categories').then((module) => module.Categories),
	Chat: () => import('./Chat').then((module) => module.Chat),
	Check: () => import('./Check').then((module) => module.Check),
	ChevronDown: () => import('./Chevron-down').then((module) => module.ChevronDown),
	ChevronLeft: () => import('./Chevron-left').then((module) => module.ChevronLeft),
	ChevronRight: () => import('./Chevron-right').then((module) => module.ChevronRight),
	ChevronUp: () => import('./Chevron-up').then((module) => module.ChevronUp),
	CircleCheck: () => import('./Circle-check').then((module) => module.CircleCheck),
	CircleMinus: () => import('./Circle-minus').then((module) => module.CircleMinus),
	CirclePlus: () => import('./Circle-plus').then((module) => module.CirclePlus),
	Clock: () => import('./Clock').then((module) => module.Clock),
	Cloud: () => import('./Cloud').then((module) => module.Cloud),
	CollectIgnore: () => import('./Collect-ignore').then((module) => module.CollectIgnore),
	CollectIn: () => import('./Collect-in').then((module) => module.CollectIn),
	CollectOut: () => import('./Collect-out').then((module) => module.CollectOut),
	Column: () => import('./Column').then((module) => module.Column),
	Compass: () => import('./Compass').then((module) => module.Compass),
	Contacts: () => import('./Contacts').then((module) => module.Contacts),
	CreditCard: () => import('./credit-card/CreditCard').then((module) => module.CreditCard),
	Cross: () => import('./Cross').then((module) => module.Cross),
	Custody: () => import('./Custody').then((module) => module.Custody),
	Dashboard: () => import('./Dashboard').then((module) => module.Dashboard),
	Database: () => import('./Database').then((module) => module.Database),
	Delete: () => import('./Delete').then((module) => module.Delete),
	DeletedUser: () => import('./DeletedUser').then((module) => module.DeletedUser),
	Depreciation: () => import('./Deprecation').then((module) => module.Depreciation),
	DinersClubCreditCard: () =>
		import('./credit-card/DinersClubCreditCard').then((module) => module.DinersClubCreditCard),
	Disc: () => import('./Disc').then((module) => module.Disc),
	DiscoverCreditCard: () => import('./credit-card/DiscoverCreditCard').then((module) => module.DiscoverCreditCard),
	Display: () => import('./Display').then((module) => module.Display),
	Document: () => import('./Document').then((module) => module.Document),
	DocumentAdd: () => import('./Document-add').then((module) => module.DocumentAdd),
	DocumentFilled: () => import('./Document-filled').then((module) => module.DocumentFilled),
	DocumentMultiple: () => import('./Document-multiple').then((module) => module.DocumentMultiple),
	DocumentRemove: () => import('./Document-remove').then((module) => module.DocumentRemove),
	Dot: () => import('./Dot').then((module) => module.Dot),
	DotsHorizontal: () => import('./Dots-horizontal').then((module) => module.DotsHorizontal),
	DotsVertical: () => import('./Dots-vertical').then((module) => module.DotsVertical),
	Download: () => import('./Download').then((module) => module.Download),
	DragIndicator: () => import('./Drag-indicator').then((module) => module.DragIndicator),
	Edit: () => import('./Edit').then((module) => module.Edit),
	Email: () => import('./Email').then((module) => module.Email),
	EmoticonHappy: () => import('./Emoticon-happy').then((module) => module.EmoticonHappy),
	EmoticonNeutral: () => import('./Emoticon-neutral').then((module) => module.EmoticonNeutral),
	EmoticonSad: () => import('./Emoticon-sad').then((module) => module.EmoticonSad),
	Eraser: () => import('./Eraser').then((module) => module.Eraser),
	Error: () => import('./Error').then((module) => module.Error),
	ExclamationMark: () => import('./ExclamationMark').then((module) => module.ExclamationMark),
	ExclamationMarkDouble: () => import('./ExclamationMark-double').then((module) => module.ExclamationMarkDouble),
	Eye: () => import('./Eye').then((module) => module.Eye),
	EyeOff: () => import('./Eye-off').then((module) => module.EyeOff),
	Feedback: () => import('./Feedback').then((module) => module.Feedback),
	Fields: () => import('./Fields').then((module) => module.Fields),
	File: () => import('./File').then((module) => module.File),
	Film: () => import('./Film').then((module) => module.Film),
	Filter: () => import('./Filter').then((module) => module.Filter),
	Fingerprint: () => import('./Fingerprint').then((module) => module.Fingerprint),
	Flag: () => import('./Flag').then((module) => module.Flag),
	FlagAlt: () => import('./Flag-alt').then((module) => module.FlagAlt),
	FlagAltFilled: () => import('./Flag-alt-filled').then((module) => module.FlagAltFilled),
	Folder: () => import('./Folder').then((module) => module.Folder),
	GamingController: () => import('./GamingController').then((module) => module.GamingController),
	Gift: () => import('./Gift').then((module) => module.Gift),
	GraduationHat: () => import('./GraduationHat').then((module) => module.GraduationHat),
	Gridview: () => import('./Gridview').then((module) => module.Gridview),
	Hand: () => import('./Hand').then((module) => module.Hand),
	HardDrive: () => import('./HardDrive').then((module) => module.HardDrive),
	Headphones: () => import('./Headphones').then((module) => module.Headphones),
	Help: () => import('./Help').then((module) => module.Help),
	Home: () => import('./Home').then((module) => module.Home),
	HorizontalLines: () => import('./HorizontalLines').then((module) => module.HorizontalLines),
	Image: () => import('./Image').then((module) => module.Image),
	Info: () => import('./Info').then((module) => module.Info),
	Items: () => import('./Items').then((module) => module.Items),
	JCBCreditCard: () => import('./credit-card/JCBCreditCard').then((module) => module.JCBCreditCard),
	Key: () => import('./Key').then((module) => module.Key),
	Keyboard: () => import('./Keyboard').then((module) => module.Keyboard),
	Kits: () => import('./Kits').then((module) => module.Kits),
	Lightbulb: () => import('./Lightbulb').then((module) => module.Lightbulb),
	Lightning: () => import('./Lightning').then((module) => module.Lightning),
	Link: () => import('./Link').then((module) => module.Link),
	LinkExternal: () => import('./Link-external').then((module) => module.LinkExternal),
	Listview: () => import('./Listview').then((module) => module.Listview),
	Loading: () => import('./Loading').then((module) => module.Loading),
	LockClosed: () => import('./Lock-closed').then((module) => module.LockClosed),
	LockOpen: () => import('./Lock-open').then((module) => module.LockOpen),
	Login: () => import('./Login').then((module) => module.Login),
	Logout: () => import('./Logout').then((module) => module.Logout),
	MaestroCreditCard: () => import('./credit-card/MaestroCreditCard').then((module) => module.MaestroCreditCard),
	Marker: () => import('./Marker').then((module) => module.Marker),
	MasterCardCreditCard: () =>
		import('./credit-card/MasterCardCreditCard').then((module) => module.MasterCardCreditCard),
	Menu: () => import('./Menu').then((module) => module.Menu),
	Microphone: () => import('./Microphone').then((module) => module.Microphone),
	Microscope: () => import('./Microscope').then((module) => module.Microscope),
	Minus: () => import('./Minus').then((module) => module.Minus),
	Mobile: () => import('./Mobile').then((module) => module.Mobile),
	Modem: () => import('./Modem').then((module) => module.Modem),
	Mouse: () => import('./Mouse').then((module) => module.Mouse),
	Music: () => import('./Music').then((module) => module.Music),
	Notification: () => import('./Notification').then((module) => module.Notification),
	NotificationSolid: () => import('./Notification-solid').then((module) => module.NotificationSolid),
	Number: () => import('./Number').then((module) => module.Number),
	PaintBrush: () => import('./Paint-brush').then((module) => module.PaintBrush),
	Parasol: () => import('./Parasol').then((module) => module.Parasol),
	Phone: () => import('./Phone').then((module) => module.Phone),
	Plus: () => import('./Plus').then((module) => module.Plus),
	Printer: () => import('./Printer').then((module) => module.Printer),
	PuzzlePiece: () => import('./PuzzlePiece').then((module) => module.PuzzlePiece),
	Qr: () => import('./Qr').then((module) => module.Qr),
	Question: () => import('./Question').then((module) => module.Question),
	QuestionCircle: () => import('./Question-circle').then((module) => module.QuestionCircle),
	Refresh: () => import('./Refresh').then((module) => module.Refresh),
	Reports: () => import('./Reports').then((module) => module.Reports),
	Reservation: () => import('./Reservation').then((module) => module.Reservation),
	RfidIcon: () => import('./RfidIcon').then((module) => module.RfidIcon),
	Rocket: () => import('./Rocket').then((module) => module.Rocket),
	RoundedSquare: () => import('./RoundedSquare').then((module) => module.RoundedSquare),
	Scanning: () => import('./Scanning').then((module) => module.Scanning),
	Search: () => import('./Search').then((module) => module.Search),
	Selector: () => import('./Selector').then((module) => module.Selector),
	Send: () => import('./Send').then((module) => module.Send),
	Server: () => import('./Server').then((module) => module.Server),
	Settings: () => import('./Settings').then((module) => module.Settings),
	Shield: () => import('./Shield').then((module) => module.Shield),
	ShoppingCart: () => import('./Shopping-cart').then((module) => module.ShoppingCart),
	Sortable: () => import('./Sortable').then((module) => module.Sortable),
	Speaker: () => import('./Speaker').then((module) => module.Speaker),
	Speedometer: () => import('./Speedometer').then((module) => module.Speedometer),
	Spotcheck: () => import('./Spotcheck').then((module) => module.Spotcheck),
	Star: () => import('./Star').then((module) => module.Star),
	StarSolid: () => import('./Star-solid').then((module) => module.StarSolid),
	Stop: () => import('./Stop').then((module) => module.Stop),
	Stopwatch: () => import('./Stopwatch').then((module) => module.Stopwatch),
	Tableview: () => import('./Tableview').then((module) => module.Tableview),
	Tag: () => import('./Tag').then((module) => module.Tag),
	Telescope: () => import('./Telescope').then((module) => module.Telescope),
	Tent: () => import('./Tent').then((module) => module.Tent),
	Ticket: () => import('./Ticket').then((module) => module.Ticket),
	Tools: () => import('./Tools').then((module) => module.Tools),
	Truck: () => import('./Truck').then((module) => module.Truck),
	Upload: () => import('./Upload').then((module) => module.Upload),
	UploadCloud: () => import('./Upload-cloud').then((module) => module.UploadCloud),
	User: () => import('./User').then((module) => module.User),
	VideoRecorder: () => import('./VideoRecorder').then((module) => module.VideoRecorder),
	VisaCreditCard: () => import('./credit-card/VisaCreditCard').then((module) => module.VisaCreditCard),
	Warning: () => import('./Warning').then((module) => module.Warning),
	Wrench: () => import('./Wrench').then((module) => module.Wrench),
} as const;
